'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var debug = require('debug');

var log = Object.assign(debug('libp2p-pubsub:peer-streams'), {
  error: debug('libp2p-pubsub:peer-streams:err')
});

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var lp = require('it-length-prefixed');

var pushable = require('it-pushable');

var _require2 = require('it-pipe'),
    pipe = _require2.pipe;

var _require3 = require('abortable-iterator'),
    abortable = _require3.source;

var AbortController = require('abort-controller').default;
/**
 * @typedef {import('../stream-muxer/types').MuxedStream} MuxedStream
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('it-pushable').Pushable<Uint8Array>} PushableStream
 */

/**
 * Thin wrapper around a peer's inbound / outbound pubsub streams
 */


var PeerStreams = /*#__PURE__*/function (_EventEmitter) {
  _inherits(PeerStreams, _EventEmitter);

  var _super = _createSuper(PeerStreams);

  /**
   * @param {object} properties - properties of the PeerStreams.
   * @param {PeerId} properties.id
   * @param {string} properties.protocol
   */
  function PeerStreams(_ref) {
    var _this;

    var id = _ref.id,
        protocol = _ref.protocol;

    _classCallCheck(this, PeerStreams);

    _this = _super.call(this);
    /**
     * @type {import('peer-id')}
     */

    _this.id = id;
    /**
     * Established protocol
     *
     * @type {string}
     */

    _this.protocol = protocol;
    /**
     * The raw outbound stream, as retrieved from conn.newStream
     *
     * @private
     * @type {null|MuxedStream}
     */

    _this._rawOutboundStream = null;
    /**
     * The raw inbound stream, as retrieved from the callback from libp2p.handle
     *
     * @private
     * @type {null|MuxedStream}
     */

    _this._rawInboundStream = null;
    /**
     * An AbortController for controlled shutdown of the inbound stream
     *
     * @private
     * @type {AbortController}
     */

    _this._inboundAbortController = new AbortController();
    /**
     * Write stream -- its preferable to use the write method
     *
     * @type {null|PushableStream}
     */

    _this.outboundStream = null;
    /**
     * Read stream
     *
     * @type {null| AsyncIterable<Uint8Array>}
     */

    _this.inboundStream = null;
    return _this;
  }
  /**
   * Do we have a connection to read from?
   *
   * @type {boolean}
   */


  _createClass(PeerStreams, [{
    key: "isReadable",
    get: function get() {
      return Boolean(this.inboundStream);
    }
    /**
     * Do we have a connection to write on?
     *
     * @type {boolean}
     */

  }, {
    key: "isWritable",
    get: function get() {
      return Boolean(this.outboundStream);
    }
    /**
     * Send a message to this peer.
     * Throws if there is no `stream` to write to available.
     *
     * @param {Uint8Array} data
     * @returns {void}
     */

  }, {
    key: "write",
    value: function write(data) {
      if (!this.outboundStream) {
        var id = this.id.toB58String();
        throw new Error('No writable connection to ' + id);
      }

      this.outboundStream.push(data);
    }
    /**
     * Attach a raw inbound stream and setup a read stream
     *
     * @param {MuxedStream} stream
     * @returns {AsyncIterable<Uint8Array>}
     */

  }, {
    key: "attachInboundStream",
    value: function attachInboundStream(stream) {
      // Create and attach a new inbound stream
      // The inbound stream is:
      // - abortable, set to only return on abort, rather than throw
      // - transformed with length-prefix transform
      this._rawInboundStream = stream;
      this.inboundStream = abortable(pipe(this._rawInboundStream, lp.decode()), this._inboundAbortController.signal, {
        returnOnAbort: true
      });
      this.emit('stream:inbound');
      return this.inboundStream;
    }
    /**
     * Attach a raw outbound stream and setup a write stream
     *
     * @param {MuxedStream} stream
     * @returns {Promise<void>}
     */

  }, {
    key: "attachOutboundStream",
    value: function () {
      var _attachOutboundStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream) {
        var _this2 = this;

        var _prevStream;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // If an outbound stream already exists, gently close it
                _prevStream = this.outboundStream;

                if (!this.outboundStream) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this.outboundStream.end();

              case 4:
                this._rawOutboundStream = stream;
                this.outboundStream = pushable({
                  onEnd: function onEnd(shouldEmit) {
                    // close writable side of the stream
                    _this2._rawOutboundStream && _this2._rawOutboundStream.reset && _this2._rawOutboundStream.reset();
                    _this2._rawOutboundStream = null;
                    _this2.outboundStream = null;

                    if (shouldEmit) {
                      _this2.emit('close');
                    }
                  }
                });
                pipe(this.outboundStream, lp.encode(), this._rawOutboundStream).catch(
                /** @param {Error} err */
                function (err) {
                  log.error(err);
                }); // Only emit if the connection is new

                if (!_prevStream) {
                  this.emit('stream:outbound');
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function attachOutboundStream(_x) {
        return _attachOutboundStream.apply(this, arguments);
      }

      return attachOutboundStream;
    }()
    /**
     * Closes the open connection to peer
     *
     * @returns {void}
     */

  }, {
    key: "close",
    value: function close() {
      // End the outbound stream
      if (this.outboundStream) {
        this.outboundStream.end();
      } // End the inbound stream


      if (this.inboundStream) {
        this._inboundAbortController.abort();
      }

      this._rawOutboundStream = null;
      this.outboundStream = null;
      this._rawInboundStream = null;
      this.inboundStream = null;
      this.emit('close');
    }
  }]);

  return PeerStreams;
}(EventEmitter);

module.exports = PeerStreams;